import styled, { css } from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';

export const WrapperInvoiceDetail = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
  span {
    font-size: 20px;
    font-weight: 00;
  }
`;
export const LoadingSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${({ theme }) => theme.colors.neutral.neutral30};
  border-top: 2px solid ${({ theme }) => theme.colors.primary50};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
export const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #808080;
`;
export const Container = styled.div`
  display: flex;
`;
export const TextAside = styled.div<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
}>`
  ${({ fontWeight, color, fontSize }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
  `}
`;
export const BoxMoreHistory = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;
export const TextCard = styled.span<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
}>`
  ${({ fontWeight, color, fontSize }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
  `}
`;
export const Box = styled.div`
  padding: 20px 24px;
  border: 1px solid #d8d8d8;
  border-radius: 12px;
  margin-bottom: 24px;
`;
export const GridInfos = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: repeat(3, 1fr); /* 2 colunas */
  gap: 16px; /* Espaçamento entre os itens */
  @media (max-width: 600px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
export const GridPerfomace = styled.div`
  display: grid;
  margin-top: 16px;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;
export const TitlePerfomace = styled.div<{
  color: string;
  fontWeight?: number;
  lineHeight?: string;
  fontSize?: string;
}>`
  ${({ theme, color, fontWeight, lineHeight, fontSize }) => css`
    font-size: ${fontSize || theme.font.sizes.medium};
    font-weight: ${fontWeight || theme.font.bold};
    color: ${color};
    line-height: ${lineHeight || '16px'};
  `}
`;
export const SubtitlePerfomace = styled.span<{
  color?: string;
  fontWeight?: number;
  lineHeight?: string;
}>`
  ${({ theme, color, fontWeight, lineHeight }) => css`
    font-size: ${theme.font.sizes.xsmall};
    color: ${color || theme.colors.neutral.neutral130};
    font-weight: ${fontWeight || 700};
    line-height: ${lineHeight || '16px'};
  `}
`;
export const Status = styled.div`
  margin-left: 1rem;
  align-items: center;
`;
export const Performance = styled.div`
  display: flex;
  align-items: center;
`;
export const NotLeads = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

export const RowPerformance = styled.div<{ marginBottom?: string }>`
  ${({ marginBottom }) => css`
    margin-top: 1.6rem;
    display: flex;
    align-items: center;
    width: 100%;
    flex-direction: row;
    margin-bottom: ${marginBottom || 0};
  `}
`;
export const Overlay = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 2;
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 60rem;
    background: ${theme.colors.neutral.neutral0};
    border-radius: 8px;
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.08);
    padding: 3.2rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
  `}
`;

export const Title = styled(Dialog.Title)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.semiBold};
    color: ${theme.colors.neutral.neutral100};
  `}
`;

export const CloseButton = styled(Dialog.Close)`
  ${({ theme }) => css`
    position: absolute;
    background: transparent;
    border: 0;
    top: 4rem;
    right: 3.5rem;
    line-height: 0;
    cursor: pointer;
    color: ${theme.colors.neutral.neutral100};
  `}
`;

// export const BaseListModal = styled.ul`
//   ${({ theme }) => css`

//   `}
// `

export const ContentDetails = styled.div`
  ${({ theme }) => css`
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;
    header {
      display: grid;
      grid-template-columns: 50% 25% 25%;
      font-size: ${theme.font.sizes.medium};
      color: ${theme.colors.neutral.neutral50};
      margin-bottom: 1rem;
    }
    .contentPlan {
      margin: 2rem 0 2rem 0;
    }
    ul + ul {
      margin-top: 2rem;
    }
    .planName {
      display: grid;
      grid-template-columns: 50% 25% 25%;

      grid-template-rows: min-content;
      row-gap: 1.6rem;
      list-style: none;
      font-size: ${theme.font.sizes.medium};
      padding-left: 0;
      &-row {
        color: ${theme.colors.neutral.neutral100};
        font-weight: ${theme.font.normal};
        &__value {
          color: ${theme.colors.neutral.neutral100};
          font-weight: ${theme.font.bold};
        }
      }
    }
    .additionalPlan {
      display: grid;
      grid-template-columns: 50% 25% 25%;
      grid-template-rows: min-content;
      row-gap: 1.6rem;
      list-style: none;
      font-size: ${theme.font.sizes.medium};
      padding-left: 0;
      &-row {
        color: ${theme.colors.neutral.neutral50};
        &__value {
          color: ${theme.colors.neutral.neutral50};
          font-weight: ${theme.font.bold};
        }
      }
    }
    footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: inherit;

      span {
        font-size: ${theme.font.sizes.medium};
        font-weight: ${theme.font.bold};
        color: ${theme.colors.neutral.neutral120};
      }
      > button {
        justify-content: flex-start;
      }
    }
  `}
`;

export const ConsumptionBarChart = styled.div`
  ${() => css`
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #f5f5f5;
    position: relative;
    margin: 1rem 0;
    overflow: hidden;
    display: flex;
  `}
`;

export const ConsumptionBarSegment = styled.div<{ width: number; color: string }>`
  ${({ width, color }) => css`
    height: 8px;
    width: ${width}%;
    background: ${color};
    transition: width 0.3s ease;
    border-radius: 4px;
  `}
`;

export const ConsumptionLegend = styled.div`
  ${() => css`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 8px;
    margin-bottom: 16px;
  `}
`;

export const LegendItem = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 8px;
  `}
`;

export const LegendDot = styled.div<{ color: string }>`
  ${({ color }) => css`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${color};
  `}
`;

export const LegendText = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.small || '12px'};
    color: ${theme.colors.neutral.neutral120 || '#808080'};
  `}
`;

export const CategoryList = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `}
`;

export const CategoryRow = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
  `}
`;

export const CategoryIconWrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    svg {
      width: 24px;
      height: 24px;
      color: #404040;
    }
  `}
`;

export const CategoryInfo = styled.div`
  ${() => css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
  `}
`;

export const CategoryName = styled.div`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 500;
    color: ${theme.colors.neutral.neutral120 || '#1A1A1A'};
  `}
`;

export const CategoryBarContainer = styled.div`
  ${() => css`
    width: 100%;
    height: 8px;
    background: #f5f5f5;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  `}
`;

export const CategoryBar = styled.div<{ width: number; color: string }>`
  ${({ width, color }) => css`
    height: 100%;
    width: ${width}%;
    background: ${color};
    border-radius: 4px;
    transition: width 0.3s ease;
  `}
`;

export const CategoryValue = styled.div`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 500;
    color: ${theme.colors.neutral.neutral50 || '#808080'};
    text-align: right;
    white-space: nowrap;
    flex-shrink: 0;
  `}
`;

